// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginModal-root-QOU0j {
	padding: 32px;
}

.LoginModal-modalCaptionLink-SpyYZ,
.LoginModal-modalCaptionLink-SpyYZ:hover,
.LoginModal-modalCaptionLink-SpyYZ:focus,
.LoginModal-modalCaptionLink-SpyYZ:active {
	color: var(--primary-link-foreground);
	font-size: 14px;
	text-decoration: underline;
	cursor: pointer;
}

.LoginModal-iconPosition-gTHqL {
	position: absolute;
	top: 15px;
	right: 10px;
}

.LoginModal-linkText-I9vtK {
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	display: grid;
	grid-template-columns: auto auto;
	grid-gap: 6px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	margin-bottom: 0px;
	margin-top: 24px;
}

.LoginModal-lineThrough-GwwzN {
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	text-align: center;
	position: relative;
	margin: 0px 0px 24px;
}

.LoginModal-linetext-yiXO4 {
	position: relative;
	display: inline-block;
}

.LoginModal-linetext-yiXO4::before {
	content: '';
	position: absolute;
	top: 9px;
	left: -30px;
	width: 26px;
	height: 1px;
	background-color: var(--primary-foreground);
}

.LoginModal-linetext-yiXO4::after {
	content: '';
	position: absolute;
	top: 9px;
	right: -30px;
	width: 26px;
	height: 1px;
	background-color: var(--primary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/LoginModal/LoginModal.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;;AAEA;;;;CAIC,qCAAqC;CACrC,eAAe;CACf,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,aAAa;CACb,gCAAgC;CAChC,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,WAAW;CACX,WAAW;CACX,2CAA2C;AAC5C","sourcesContent":[".root {\n\tpadding: 32px;\n}\n\n.modalCaptionLink,\n.modalCaptionLink:hover,\n.modalCaptionLink:focus,\n.modalCaptionLink:active {\n\tcolor: var(--primary-link-foreground);\n\tfont-size: 14px;\n\ttext-decoration: underline;\n\tcursor: pointer;\n}\n\n.iconPosition {\n\tposition: absolute;\n\ttop: 15px;\n\tright: 10px;\n}\n\n.linkText {\n\tfont-size: 14px;\n\tline-height: 18px;\n\tfont-weight: 500;\n\tdisplay: grid;\n\tgrid-template-columns: auto auto;\n\tgrid-gap: 6px;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-bottom: 0px;\n\tmargin-top: 24px;\n}\n\n.lineThrough {\n\tfont-size: 14px;\n\tline-height: 18px;\n\tfont-weight: 500;\n\ttext-align: center;\n\tposition: relative;\n\tmargin: 0px 0px 24px;\n}\n\n.linetext {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n\n.linetext::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tleft: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--primary-foreground);\n}\n\n.linetext::after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tright: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--primary-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LoginModal-root-QOU0j`,
	"modalCaptionLink": `LoginModal-modalCaptionLink-SpyYZ`,
	"iconPosition": `LoginModal-iconPosition-gTHqL`,
	"linkText": `LoginModal-linkText-I9vtK`,
	"lineThrough": `LoginModal-lineThrough-GwwzN`,
	"linetext": `LoginModal-linetext-yiXO4`
};
module.exports = ___CSS_LOADER_EXPORT___;
